<app-task-view class="task-popup__window task-popup__window_full-screen"></app-task-view>
